import featuredOffers150x150 from './FeaturedOffers150x150';

export default featuredOffers150x150;
